export default "__VITE_ASSET__z5C6xWTZ__"